import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import WarningIcon from '@mui/icons-material/Warning';
import { Stack } from '@mui/material';

const style = {
    position: 'absolute',
    top: '38%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: '#ffffff',
    border: '0px solid #000',
    borderCollapse: 'collapse',
    borderRadius: '6px',
    boxShadow: 8,
    p: 4,
    outline: 'none',
};

export default function (props) {

    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    return (
        <div style={{ outline: 'none' }}>
            <Modal
                open={props.show}
                onClose={() => { props.handle_close(); }}
                //aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                sx={{
                    boxShadow: 'none', '.MuiOutlinedInput-notchedOutline': { border: 0 }
                    , border: 'none', outline: 'none',
                }}
            >
                <Box sx={style}>
                    {/*<Typography id="modal-modal-title" variant="h6" component="h2">
            {props.text}
          </Typography>*/}
                    
                    <table style={{width:'100%',fontFamily: 'Roboto', fontWeight: 'normal',}}><tr>
                        <td style={{width:'40px',textAlign:'center'}}><WarningIcon style={{ color: '#888888', fontSize: '42px',marginRight:'12px' }} /></td>
                        <td style={{width:'6px',fontSize:'2px'}}>&nbsp;&nbsp;</td>
                        <td style={{textAlign:'left',verticalAlign:'center',lineHeight:'22px',fontWeight:'normal',color:'#222222'}}>{props.text}</td>
                    </tr></table>

                    <Button variant="text" sx={{ color: '#222222', fontSize: '13px', marginTop: '11px', width: '100%', fontFamily: 'Roboto', fontWeight: 'normal', }} onClick={() => { props.handle_close() }}>{props.confirm_text}</Button>
                </Box>
            </Modal>
        </div>
    );
}